import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiBtnUploadFileComponent } from './btn-upload-file.component';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { FiBtnMobileAppOpenCameraDirective } from '@fi-shared/fi-insert-media/btn-upload-file/fi-btn-mobile-app-open-camera.directive';
import { FiAppTextSharedModule } from '@fi-shared/app-text';

@NgModule({
    imports: [CommonModule, MatButtonModule, MatMenuModule, FiAppTextSharedModule],
    declarations: [FiBtnUploadFileComponent, FiBtnMobileAppOpenCameraDirective],
    exports: [FiBtnUploadFileComponent, FiBtnMobileAppOpenCameraDirective],
})
export class FiBtnUploadFileModule {}
